<template>
  <s-modal
    v-model="showModal"
    :title="$t('engineering.templates-simulation.save-template')"
    size="md"
    hide-footer
    cancel-confirm-message-code="MC006"
    @cancel="cancel"
  >
    <b-container fluid class="p-4">
      <b-row
        no-gutters
      >
        <span
          class="mb-4"
        >
          {{ $t('engineering.templates-simulation.when-you-save-template') }}
        </span>
        <label for="input-live">{{ $t('engineering.templates-simulation.template-name') }}</label>
        <b-form-input
          v-model="$v.nameTemplate.$model"
          id="input-live"
          :state="$bsStateValidator($v.nameTemplate.$error)"
          :validation="$v.nameTemplate"
          :invalid="$v.nameTemplate.$error"
          trim
          @blur.native="$v.nameTemplate.$touch()"
        ></b-form-input>
        <b-form-invalid-feedback
          :state="$bsStateValidator($v.nameTemplate.$error)">
          {{ nameTemplateErrors }}
        </b-form-invalid-feedback>
        <div class="d-flex flex-row-reverse w-100 mt-5">
          <b-button
            variant="primary"
            class="save-simulation text-right"
            :disabled="disableButtonSaving"
            @click="saveTemplateSimulation"
          >
            {{ $t('engineering.templates-simulation.save-template') }}
          </b-button>
          <b-button
            variant="secondary"
            @click="cancel"
          >
            {{ $t('engineering.templates-simulation.cancel') }}
          </b-button>
        </div>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'SaveTemplateModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    statusTemplateSituation: {
      required: false,
      type: String,
    },
    nameTemplateEdit: {
      type: String,
      default: null,
      required: false,
    },
  },
  validations() {
    return {
      nameTemplate: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(80),
      },
    };
  },
  data() {
    return {
      disableButtonSaving: true,
      nameTemplate: null,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    nameTemplateErrors() {
      if (!this.$v.nameTemplate.minLength || !this.nameTemplate) {
        this.disabledButtonSave(true);
        return this.$t('messages.MG001.message', { 0: '2', 1: '80' });
      }
      if (!this.$v.nameTemplate.maxLength) {
        this.disabledButtonSave(true);
        return this.$t('messages.MA058.message', { NroCaracteres: '80' });
      }
      this.disabledButtonSave(false);
      return null;
    },
  },
  methods: {
    disabledButtonSave(result) {
      this.disableButtonSaving = result;
    },
    saveTemplateSimulation() {
      if (this.statusTemplateSituation === 'new') {
        this.$emit('saveTemplateSimulation', this.nameTemplate);
      } else if (this.statusTemplateSituation === 'edit') {
        this.$emit('editTemplateSimulation', this.nameTemplate);
      }

      this.showModal = false;
    },
    cancel() {
      this.showModal = false;
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.$v.$reset();
        this.nameTemplate = null;
      }
    },
    statusTemplateSituation() {
      if (this.statusTemplateSituation === 'edit' && this.nameTemplateEdit !== '') {
        this.nameTemplate = this.nameTemplateEdit;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
::v-deep .modal-header
  display: block

@page
  margin: 0 auto

  @media print
    .modal-dialog,
    .modal-content
      max-width: 100vw
      width: 100vw
      height: 100vh
      margin: 0 auto

    .modal-content
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
</style>
